import React from 'react';
import { useTheme } from '../../DataStore/ThemeContext';
import { useStudent } from '../../DataStore/StudentContext';
import ActivityLoader from '../Common/ActivityLoader';

const ContactSection = ({ contacts }) => {
  const { openSettings } = useTheme();
  const { studentId, getStudentContacts, setMakeDefaultContact, setDeleteContact } = useStudent();

  const handleAddContact = () => {
    openSettings("Add Contact", "NewStudentContact", {
      studentId,
      onSave: () => {
        getStudentContacts(studentId);
      },
    });
  };

  const handleSetDefault = (contact) => {
    setMakeDefaultContact({
      show: true,
      contact: contact
    });
  };

  const handleEditContact = (contact) => {
    openSettings("Edit Contact", "EditStudentContact", {
      contact: contact,
      studentId: studentId,
      onSave: () => {
        getStudentContacts(studentId);
      },
    });
  }

  const handleDeleteContact = (contact) => {
    setDeleteContact({
      show: true,
      contact: contact
    });
  }

  return (
    <div className="card shadow-sm">
      <div className="card-header bg-white d-flex justify-content-between align-items-center">
        <h6 className="card-title mb-0">
          <i className="fa fa-phone text-primary mr-2"></i>
          Relatives / Guardians
        </h6>
        <button className="btn btn-sm btn-outline-primary" onClick={handleAddContact}>
          <i className="fa fa-plus"></i> Add Contact
        </button>
      </div>
      <div className="card-body overflow-auto" style={{ maxHeight: "40vh" }}>
        {contacts !== '404' ? (
          <div className="list-group">
            {Array.isArray(contacts) ? contacts.map((contact) => (
              <div
                key={contact.id}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong>
                    {contact.contact_name}
                    {contact.default_contact && (
                      <i className="fa fa-check-circle text-success ml-2" title="Default Contact"></i>
                    )}
                  </strong>
                  <br />
                  <small className="text-muted">
                    {contact.contact_type?.type_name} - {contact.contact}
                  </small>
                </div>
                <div className="d-flex align-items-center">
                  {!contact.default_contact && (
                    <button
                      className="btn btn-sm btn-outline-success mr-2"
                      onClick={() => handleSetDefault(contact)}
                    >
                      <i className="fa fa-star"></i>
                    </button>
                  )}
                  <button className="btn btn-sm btn-outline-secondary mr-2" onClick={() => handleEditContact(contact)}>
                    <i className="fa fa-edit"></i>
                  </button>
                  <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteContact(contact)}>
                    <i className="fa fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            )) : <ActivityLoader />}
          </div>
        ) : (
          <p className="text-muted">No contacts found for student.</p>
        )}
      </div>
    </div>
  );
};

export default ContactSection;
